document.addEventListener('DOMContentLoaded', function () {
  var anchorLinks = document.querySelectorAll('a.header__anchor-link');

  anchorLinks.forEach(function (link) {
    link.addEventListener('click', function () {
      var details = this.closest('details');

      // Only act if this link is inside the open menu drawer
      if (details && details.hasAttribute('open')) {
        var summary = details.querySelector('summary');

        if (summary) {
          // This uses the theme’s built-in close behavior (removes overlay, body locks, etc.)
          summary.click();
        } else {
          // Fallback: close the details
          details.removeAttribute('open');
        }
      }
    });
  });
});
